// SubscriptionAddon Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React from 'react'
import PropTypes from 'prop-types'

import { Button, Icon } from '@rodeo-dev/legos'

const SubscriptionAddon = ({
  title,
  isTeamUSA,
  price,
  description,
  allowPurchase,
  activateButtonText,
  deactivateButtonText,
  onClick,
  isAddonActive,
  url,
  urlText
}) => {
  const showDescriptionLink = url && urlText

  const priceIconRight = isTeamUSA
    ? 'icon icon-setting-priceusd'
    : 'icon icon-setting-priceeuro'

  const handleClick = () => {
    onClick && onClick(!isAddonActive)
  }

  return (
    <div className='rightcol-plannerinfo'>
      <div className='head'>
        <h2 className='title'>{title}</h2>
      </div>
      <div className='pricerow pricerow-planner'>
        <div className='pricecol'>
          <i className={priceIconRight} />
          <h2 className='price'>{price}</h2>
        </div>
        <div className='infocol'>
          <p className='cont'>{description}</p>
          {allowPurchase && (
            <Button
              type='button'
              color='primary'
              size='small'
              onClick={handleClick}
              startIcon={
                <Icon
                  icon={isAddonActive ? 'check' : 'shopping-cart'}
                  color='inherit'
                />
              }
            >
              {isAddonActive ? deactivateButtonText : activateButtonText}
            </Button>
          )}
        </div>
      </div>
      {showDescriptionLink && (
        <p className='cont expensesLink'>
          <Icon
            color='action'
            fontSize='small'
            prefix='fas'
            icon='info-circle'
          />
          <a href={url}>{urlText}</a>
        </p>
      )}
    </div>
  )
}

SubscriptionAddon.propTypes = {
  title: PropTypes.string,
  // isTeamUSA: to show the same currency as in Chargebee, and they have different addons for different currencies.
  isTeamUSA: PropTypes.bool,
  price: PropTypes.string,
  description: PropTypes.string,
  // allowPurchase: clicking buttons when the subscription status is 'cancelled' or 'payment failed'
  // will activate the subscription without payment, so we hide it
  // and Chargebee does not allow to disable addon when the subscription status is 'cancelled'.
  // also we don't want users to be able to activate Klippa in trial - because Klippa doesn't have trial option.
  allowPurchase: PropTypes.bool,
  activateButtonText: PropTypes.string,
  deactivateButtonText: PropTypes.string,
  onClick: PropTypes.func,
  isAddonActive: PropTypes.bool,
  url: PropTypes.string,
  urlText: PropTypes.string
}

export default SubscriptionAddon
